import { render, staticRenderFns } from "./AppInputScanFadly.vue?vue&type=template&id=2cc96548&scoped=true&"
import script from "./AppInputScanFadly.vue?vue&type=script&lang=js&"
export * from "./AppInputScanFadly.vue?vue&type=script&lang=js&"
import style0 from "./AppInputScanFadly.vue?vue&type=style&index=0&id=2cc96548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc96548",
  null
  
)

export default component.exports